// extracted by mini-css-extract-plugin
export var pageTitle = "faq-modules--pageTitle--1Httu";
export var tabs = "faq-modules--tabs--hsilT";
export var tabsScroll = "faq-modules--tabsScroll--asbMi";
export var tab = "faq-modules--tab--19aU4";
export var plain = "faq-modules--plain--25edD";
export var enter = "faq-modules--enter--21JXv";
export var exit = "faq-modules--exit--1e57G";
export var enterActive = "faq-modules--enterActive--3Ux8p";
export var exitActive = "faq-modules--exitActive---G1DA";